import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Stethoscope, Home, HeartPulse, Sparkles, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
const services = [{
  icon: Stethoscope,
  title: 'Medical Care',
  description: 'Comprehensive medical support from certified professionals, tailored to your specific health needs.'
}, {
  icon: Home,
  title: 'Home Care',
  description: 'Compassionate daily assistance allowing you or your loved ones to age comfortably in place.'
}, {
  icon: HeartPulse,
  title: 'Therapy & Rehab',
  description: 'Personalized physical and occupational therapy programs to restore mobility and independence.'
}, {
  icon: Sparkles,
  title: 'Wellness Programs',
  description: 'Holistic activities designed to nurture mental, emotional, and social well-being.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function ServicesSection() {
  return <section id="services" className="py-24 bg-white" data-id="element-175">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-176">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-177">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-serif text-chocolate mb-6" data-id="element-178">
            Our Services
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-chocolate/70" data-id="element-179">
            We provide a full spectrum of premium healthcare services, designed
            to support you at every stage of your wellness journey with dignity
            and respect.
          </motion.p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8" data-id="element-180">
          {services.map((service, index) => <motion.div key={index} variants={itemVariants} className="group block bg-nude-light rounded-3xl p-8 shadow-soft hover:shadow-soft-lg transition-all duration-300 hover:-translate-y-2 border border-transparent hover:border-nude" data-id="element-181">
              <div className="w-14 h-14 rounded-2xl bg-nude flex items-center justify-center text-chocolate mb-6 group-hover:bg-gold group-hover:text-white transition-colors duration-300" data-id="element-182">
                <service.icon size={28} strokeWidth={1.5} data-id="element-183" />
              </div>
              <h3 className="text-xl font-serif font-semibold text-chocolate mb-3" data-id="element-184">
                {service.title}
              </h3>
              <p className="text-chocolate/70 leading-relaxed mb-6" data-id="element-185">
                {service.description}
              </p>
              <Link to="/services" className="flex items-center text-gold font-medium text-sm group-hover:text-chocolate transition-colors" data-id="element-186">
                Learn more{' '}
                <ArrowRight size={16} className="ml-1 group-hover:translate-x-1 transition-transform" data-id="element-187" />
              </Link>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}